var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', _vm._g({
    staticClass: "base-button tw-relative tw-overflow-hidden tw-border tw-font-[400] disabled:tw-cursor-not-allowed",
    class: [_vm.sizeClass, _vm.colorClass, _vm.disabledClass, _vm.roundedClass],
    attrs: {
      "disabled": _vm.$attrs.disabled || _vm.loading
    }
  }, _vm.$listeners), [!_vm.outline && !_vm.text ? _c('div', {
    staticClass: "[ ] [ ] tw-absolute tw-left-0 tw-top-0 tw-flex tw-size-full tw-gap-1 tw-bg-black tw-opacity-0 tw-transition hover:tw-opacity-10"
  }) : _vm._e(), _vm._t("default"), _vm.loading ? _c('IconLoading', {
    staticClass: "tw-absolute tw-left-[10px] tw-top-1/2 tw-size-[18px] -tw-translate-y-1/2",
    class: _vm.loadingColorClass
  }) : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };